export class DeadLetterMigrationStatements {
  migrations = [`
    CREATE TABLE IF NOT EXISTS dead_letter (
      id       TEXT PRIMARY KEY,
      source   TEXT,
      json     TEXT,
      failedAt TEXT,
      reason   TEXT
    );`
  ]
}